import React from 'react';
import { useIntl } from 'react-intl';
import imgOne from '@/images/banner-repairs-1.png';
import imgTwo from '@/images/banner-repairs-2.png';
import InfoStepModal from '../InfoStepModal/InfoStepModal';

const InfoRepairsModal = ({ isOpen, onClose, onConfirm }) => {
  const intl = useIntl();
  const steps = [
    {
      label: intl.formatMessage({ id: 'infoRepairsModal.imgAlt1' }),
      text: intl.formatMessage({ id: 'infoRepairsModal.text1' }),
      imgPath: imgOne,
    },
    {
      label: intl.formatMessage({ id: 'infoRepairsModal.imgAlt2' }),
      text: intl.formatMessage({ id: 'infoRepairsModal.text2' }),
      imgPath: imgTwo,
    },
  ];
  return (
    <InfoStepModal
      title={intl.formatMessage({ id: 'infoRepairsModal.changesProperty' })}
      textNextImg={intl.formatMessage({ id: 'infoStepModal.availableOnPlans' })}
      steps={steps}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default InfoRepairsModal;
